<template>
  <div>
    <div
      class="media-item-wrapper"
      @click="openModal"
    >
      <div class="media-item-card border-light rounded overflow-hidden">
        <div
          v-if="isVideo"
          class="media-item-card__badge d-flex align-items-center bg-danger"
        >
          <FeatherIcon
            icon="PlayCircleIcon"
            size="18"
          />
          <span>Video</span>
        </div>

        <b-img
          v-if="!isVideo"
          :src="dataItem.file_name"
          class="media-item-card__media"
          fluid
          rounded
        />

        <video
          v-else
          :src="dataItem.file_name"
          class="media-item-card__media"
          preload="metadata"
          muted
          playsinline
          loop
          controlslist="nodownload noremoteplayback nofullscreen"
          disablepictureinpicture
          tabindex="-1"
          aria-hidden="true"
        />

        <div class="media-item-card__overlay">
          <b-button
            variant="success"
            class="btn-icon"
            @click.stop="openModal"
          >
            <FeatherIcon icon="EyeIcon" /> Görüntüle
          </b-button>
          <b-button
            variant="primary"
            class="btn-icon ml-50"
            :disabled="downloading"
            @click.stop="downloadMedia"
          >
            <b-spinner
              v-if="downloading"
              small
            />
            <FeatherIcon
              v-else
              icon="DownloadIcon"
            /> İndir
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalData.status"
      size="xl"
      hide-footer
      title="Medya Galeri"
      centered
    >
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <b-list-group>
            <b-list-group-item>
              <div>
                <div class="font-weight-bold text-primary">
                  Başlık
                </div>
                <b-input-group
                  v-if="!isView"
                  size="sm"
                  class="mt-50"
                >
                  <b-form-input
                    v-model="titleDraft"
                    placeholder="Başlık"
                    :disabled="savingTitle"
                    @keydown.enter="saveTitle"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      :disabled="savingTitle || !titleChanged"
                      @click="saveTitle"
                    >
                      <b-spinner
                        v-if="savingTitle"
                        small
                      />
                      <template v-else>
                        Kaydet
                      </template>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <div v-else>
                  {{ dataItem.title || '-' }}
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div>
                <div class="font-weight-bold text-primary">
                  Medya Tipi
                </div>
                <div>
                  {{ dataItem.media_type === 'image'? 'Görsel' : 'Video' }}
                  <div class="font-small-3 text-muted">
                    {{ dataItem.file_type }}
                  </div>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div>
                <div class="font-weight-bold text-primary">
                  Dosya Boyutu
                </div>
                <div>
                  {{ dataItem.file_size | toNumber }} KB
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <div>
                <div class="font-weight-bold text-primary">
                  Yükleyen Kullanıcı
                </div>
                <div>
                  {{ dataItem.username }}
                  <div class="font-small-3 text-muted">
                    {{ moment(dataItem.created).format('DD.MM.YYYY HH:mm') }}
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
          <div class="text-center mt-1">
            <b-button
              variant="primary"
              pill
              :disabled="downloading"
              @click="downloadMedia"
            >
              <b-spinner
                v-if="downloading"
                small
              />
              <FeatherIcon
                v-else
                icon="DownloadIcon"
              />
              İndir
            </b-button>
            <b-button
              v-if="!isView"
              variant="danger"
              pill
              class="ml-50"
              @click="removeData(modalMedia.id)"
            >
              <FeatherIcon icon="TrashIcon" />
              Dosya Sil
            </b-button>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <div class="media-modal-preview">
            <b-img
              v-if="modalMedia && modalMedia.media_type === 'image'"
              :src="modalMedia.file_name"
              fluid
              class="media-modal-preview__image"
            />

            <video
              v-else-if="modalMedia"
              :src="modalMedia.file_name"
              class="media-modal-preview__video"
              controls
              autoplay
              muted
              playsinline
            />

            <div
              v-else
              class="text-center text-muted"
            >
              Yükleniyor...
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BImg, BButton, BModal, BRow, BCol, BListGroup, BListGroupItem, BInputGroup, BInputGroupAppend, BFormInput, BSpinner,
} from 'bootstrap-vue'
import mediaItemActions from '@/mixins/mediaItemActions'

export default {
  name: 'MediaItem',
  components: {
    BImg,
    BButton,
    BModal,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BSpinner,
  },
  mixins: [mediaItemActions],
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
    getDataList: {
      type: Function,
      required: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      galleryModule: 'serviceMediaGallery',
      modalData: {
        status: false,
        data: [],
      },
    }
  },
  computed: {
    isVideo() {
      return this.dataItem?.media_type === 'video'
    },
    modalMedia() {
      return this.modalData.data
    },
  },
  methods: {
    openModal() {
      this.modalData.status = true
      this.modalData.data = this.dataItem
      this.resetTitleDraft()
    },
    removeData(id) {
      if (!this.isView) {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('serviceMediaGallery/removeData', id)
              .then(response => {
                if (response.status) {
                  this.modalData.status = false
                  this.getDataList()
                  this.$swal({
                    icon: 'success',
                    title: this.$store.state.app.removeResultTitle,
                    text: this.$store.state.app.removeResultMessage,
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
          }
        })
      }
    },
  },
}
</script>

<style scoped>
.media-item-wrapper {
  width: 100%;
  cursor: pointer;
}

.media-item-card {
  aspect-ratio: 4 / 3;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-item-card__media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: calc(var(--bs-border-radius, 0.357rem) - 2px);
}

.media-item-card__overlay {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%, 15px);
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}

.media-item-card:hover .media-item-card__overlay {
  opacity: 1;
  transform: translate(-50%, 0);
  pointer-events: auto;
}

video.media-item-card__media {
  background-color: #000;
  pointer-events: none;
}

.media-item-card__badge {
  position: absolute;
  top: 10px;
  padding: 4px 10px;
  border-radius: 999px;
  color: #fff;
  font-size: 0.75rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.media-modal-preview {
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: #f1f1f1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-modal-preview__image,
.media-modal-preview__video {
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  background-color: #f1f1f1;
}
</style>
